/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 *
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { useEffect } from 'react'

import { useCryptographyStore } from '@builddocs/cryptography-js'
import { useLocalUser } from '@builddocs/data-management'
import { tracerError } from '@builddocs/data-management'
import { AppNotification } from '@builddocs/exdoc-app/ui-layout'
import { FeatureFlagProvider } from '@builddocs/system'
import { Alert, AlertTitle, Stack, Typography } from '@mui/material'
import * as Sentry from '@sentry/react'
import { ReactQueryDevtools } from 'react-query/devtools'
import { BrowserRouter as Router } from 'react-router-dom'
import { toast } from 'react-toastify'

import RootScreen from './RootScreen'

import 'react-toastify/dist/ReactToastify.css'

toast.configure()

const isDevEnvironment =
  process.env.NODE_ENV === 'development' || process.env.NX_ENV === 'development'

const App = () => {
  const { userId } = useLocalUser()

  const { init } = useCryptographyStore()

  useEffect(() => {
    init()
  }, [init])

  return (
    <>
      {isDevEnvironment ? (
        <Stack
          alignItems="end"
          direction="column"
          spacing={1}
          sx={{
            position: 'fixed',
            top: 0,
            right: 4,
            zIndex: 10000,
            pointerEvents: 'none',
          }}
        >
          <Typography color="error.main" mb={1} variant="subtitle1">
            DEV режим
          </Typography>
          <Typography color="error.main" mb={1} variant="subtitle1">
            BRANCH NAME: {process.env.NX_BRANCH_NAME}
          </Typography>
          <Typography color="error.main" mb={1} variant="subtitle1">
            HEAD SHA: {process.env.NX_CI_COMMIT_SHA}
          </Typography>
        </Stack>
      ) : null}
      <Router>
        <FeatureFlagProvider>
          <Sentry.ErrorBoundary
            beforeCapture={scope => {
              scope.setTag('location', 'Root')
            }}
            fallback={({ error }) => {
              tracerError.error(error, {
                userId: userId ?? 'undefined',
                severity: 'fatal',
                issueKey: 'boundary/root-layout',
              })
              return (
                <Alert severity="error">
                  <AlertTitle>Произошла какая-то ошибка</AlertTitle>
                  {error.toString}
                </Alert>
              )
            }}
          >
            <AppNotification />
            {/*<AllertComponent/>*/}
            <RootScreen />
            <ReactQueryDevtools initialIsOpen={false} position="bottom-left" />
          </Sentry.ErrorBoundary>
        </FeatureFlagProvider>
      </Router>
    </>
  )
}

export default Sentry.withProfiler(App, { name: 'Executive documentation' })
